module.exports = __webpack_public_path__ + "static/media/done-animation.fd03c527.gif";